import React, { memo, useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import Masonry from 'react-masonry-component';
import { clearCTA, fetchCTA } from '../../../Store/actions/commonActions';

import SampleCollectionSwiper from './SampleCollectionSwiper';
import ShowCardByType from './ShowCardByType';

const CtaSection = ({ position = '', page_name = '', page_id = 0 }) => {
  const [ctaData, setCtaData] = useState([]);
  const [scheduleCtaData, setScheduleCtaData] = useState([]);
  const [sampleCollectionCta, setSampleCollectionCta] = useState([]);
  const dispatch = useDispatch();
  const ctaDataArray = useSelector((state) => state.common.cta_data);

  const masonryPositions = ['before_content', 'after_content'];

  useEffect(() => {
    if (position == 'before_content' || position == 'top') {
      dispatch(clearCTA());
      dispatch(fetchCTA(page_name, page_id, (response) => {}));
    }
    return () => {
      dispatch(clearCTA());
    };
  }, [position, page_name, page_id]);

  const filterJsonByPosition = (data = [], matching_value = '') => {
    return data.filter((x) => x.position == matching_value);
  };

  const filterDataByCtaType = (data = [], matching_value = '') => {
    let temp = [];
    if (matching_value == 'schedule') {
      temp = data.filter((x) => x.cta_type === 'schedule');
    } else if (matching_value == 'sample_collection') {
      temp = data.filter((x) => x.cta_type === 'sample_collection');
    } else {
      temp = data.filter((x) => x.cta_type !== 'schedule' && x.cta_type !== 'sample_collection');
    }
    return temp;
  };
  useEffect(() => {
    if (ctaDataArray?.length > 0 && position) {
      let filteredCtaDataByPosition = filterJsonByPosition(ctaDataArray, position);
      if (filteredCtaDataByPosition?.length > 0) {
        setScheduleCtaData(filterDataByCtaType(filteredCtaDataByPosition, 'schedule'));
        setSampleCollectionCta(filterDataByCtaType(filteredCtaDataByPosition, 'sample_collection'));
        setCtaData(filterDataByCtaType(filteredCtaDataByPosition));
      }
    } else {
      setCtaData([]);
      setSampleCollectionCta([]);
      setScheduleCtaData([]);
    }
  }, [ctaDataArray, position]);

  return (
    <>
      {ctaData?.length > 0 ? (
        <>
          {!masonryPositions.includes(position) ? (
            <>
              {ctaData?.length > 0 &&
                ctaData?.map((key, ind) => (
                  <ShowCardByType
                    data={key}
                    position={position}
                    index={ind}
                    key={'after_before' + ind}
                    page_name={page_name}
                    page_id={page_id}
                  />
                ))}
            </>
          ) : (
            <div className={'w-100 ctaSection mt-3'}>
              <Masonry className="ms-n4 ms-md-n5 mt-n4 mt-md-n5 me-0 mt-2">
                {ctaData?.length > 0 &&
                  ctaData?.map((key, ind) => (
                    <ShowCardByType
                      data={key}
                      position={position}
                      index={ind}
                      key={'content_cta' + ind}
                      page_name={page_name}
                      page_id={page_id}
                    />
                  ))}
              </Masonry>
            </div>
          )}
        </>
      ) : null}
      {scheduleCtaData?.length > 0 ? (
        <>
          <div className={'w-100 ctaSection ' + (ctaData?.length > 0 ? 'mt-3' : '')}>
            {scheduleCtaData?.length > 0 &&
              scheduleCtaData?.map((key, ind) => (
                <ShowCardByType
                  data={key}
                  position={position}
                  index={ind}
                  key={'schedule' + ind}
                  page_name={page_name}
                  page_id={page_id}
                />
              ))}
          </div>
        </>
      ) : null}
      {sampleCollectionCta?.length > 0 ? (
        <SampleCollectionSwiper sampleCtaData={sampleCollectionCta} />
      ) : null}
    </>
  );
};
export default memo(CtaSection);
